import { SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { Client } from '@df/core/service/client';
import { Status } from '@df/core/status';
import { ImageModule } from '@df/module-image/image.module';
import { OptionImagePipe } from '@df/ui/common/option-image.pipe';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ActionComponent } from 'projects/app-default/src/app/ui/api/action.component';
import { ScrollNavTargetDirective } from 'projects/app-default/src/app/ui/scroll-nav/scroll-nav-target.directive';
import { LocalProduct } from '../../../model/product/product.decorator';
import { NFeatureSectionModal } from './modal/feature-section-modal.component';

@Component({
    selector: 'features-section',
    templateUrl: './features-section.html',
    standalone: true,
    imports: [ScrollNavTargetDirective, TranslationModule, SlicePipe, ImageModule, OptionImagePipe, ActionComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeaturesSectionComponent {
    @Input()
    product: LocalProduct<IProductDataV3>;

    constructor(
        protected client: Client,
        private dfModalService: DfModalService
    ) {}

    protected modalStatus = new Status();

    protected openModal() {
        const data: NFeatureSectionModal.IInitiatorData = {
            product: this.product
        };
        this.dfModalService.open(this.modalStatus, NFeatureSectionModal.featureSectionModalId, undefined, data);
    }
}
